import React from "react";
import PropTypes from "prop-types";
import "intl";
import "intl/locale-data/jsonp/en";

import Component from "components/component";
import { stripZeros, numberFormat } from "../../lib/helpers";

export default class Currency extends Component {
  static propTypes = {
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  };

  render() {
    const price = stripZeros(numberFormat().format(this.props.price));

    return <span>${price}</span>;
  }
}
